
import SearchWrapper from "@/components/base/input/SearchWrapper"
import ProgressLinear from "@/components/base/ProgressLinear"

import { mapActions, mapGetters } from "vuex"
import { mdiDelete } from "@mdi/js"
import colors from "@/mixins/colors"
const debounce = require("lodash.debounce")

export default {
    name: "ApprenticeshipSearch",
    components: {
        SearchWrapper,
        ProgressLinear,
        Hashtag: () => import("@/components/base/Hashtag"),
    },
    mixins: [colors],
    data() {
        return {
            mdiDelete,
            searchInput: "",
            exampleSuggestions: [
                "Fachinformatiker",
                "Stahl",
                "Büro",
                "draußen",
                "Fahrrad",
            ],
            isSearchPending: false,
            jobResults: [],
            tagResults: [],
            debouncedSearch: debounce(this.sendRequest, 500, {
                trailing: true,
            }),
            dialog: false,
            inputBuffer: [],
        }
    },
    mounted() {
        this.sendRequest()
    },
    computed: {
        ...mapGetters("search", [
            "filterName",
            "location",
            "filter",
            "channel",
        ]),
        returnTags() {
            return this.tagResults.slice(0, 10)
        },
        returnJobs() {
            return this.jobResults.slice(0, 3)
        },
    },
    methods: {
        ...mapActions("search", ["setFilterName"]),
        mapUmlaute(value) {
            return value
                .replace(/ä/g, "a")
                .replace(/ö/g, "o")
                .replace(/ü/g, "u")
                .replace(/ß/g, "s")
        },
        removeCategory() {
            let queryParams = { ...this.$route.query }
            delete queryParams.category
            this.$router.push({ query: queryParams })
        },
        removeTag() {
            let queryParams = { ...this.$route.query }
            delete queryParams.tags
            this.$router.push({ query: queryParams })
        },
        jobRoute(job) {
            return this.$store.getters["search/route"]({
                category: "Ausbildung",
                filters: { job },
            })
        },
        businessRoute(business) {
            return this.$store.getters["search/route"]({
                category: "Ausbildung",
                filters: { business },
            })
        },
        routeToTag(tag) {
            return this.$store.getters["search/route"]({
                category: "Ausbildung",
                filters: {
                    tags: tag,
                    category: this.filter ? this.filter.category : null,
                },
            })
        },
        onSearchChange() {
            this.inputBuffer.push(this.searchInput)
            this.isSearchPending = true
            // debounced this.sendRequest()
            this.debouncedSearch()
        },
        async sendRequest() {
            const response = await this.$axios
                .$post("/api/search/autocomplete_apprenticeship ", {
                    search: this.mapUmlaute(this.searchInput),
                    location: this.location,
                    category: this.filter?.category,
                    channel: this.channel,
                })
                .catch((err) => console.warn(err))
            if (!response) return
            this.$oabalytics.trackEvent(`v1search_search_apprenticeship`, {
                query: this.searchInput,
                numResults: response.jobResults?.length,
                input: this.inputBuffer,
            })
            this.inputBuffer = []
            this.jobResults = response.jobs
            this.tagResults = response.tags
            this.isSearchPending = false
        },
        clearSearch() {
            this.searchInput = ""
            this.jobResults = []
            this.setFiltername = ""
            this.$refs.apprenticeshipSearchInput?.focus()
            this.sendRequest()
        },
    },
    destroyed() {
        this.clearSearch()
    },
}
